'use client';

import React from 'react';
import ReactPlayer from 'react-player';

interface VideoPlayerProps {
  url: string;
  width?: string | number;
  height?: string | number;
  autoplay?: boolean;
  loop?: boolean;
  controls?: boolean;
}

export default function VideoPlayer({
  url,
  width = '100%',
  height = '500px',
  autoplay = true,
  loop = false,
  controls = true,
}: VideoPlayerProps) {
  return (
    <ReactPlayer
      src={url}
      controls={controls}
      width={width}
      height={height}
      playing={autoplay}
      muted={autoplay}
      loop={loop}
    />
  );
}
